import Api from "shared/service/api/api";

export const LOAD_USER_COAUTHORS = "loadUserCoauthors";
export const LOAD_USER_AS_COAUTHOR = "loadUserAsCoauthor";

export const SET_USER_COAUTHORS = "setUserCoauthors";
export const SET_USER_AS_COAUTHOR = "setUserAsCoauthor";

const state = {
  userCoauthors: {
    byItem: [],
    byCoauthor: [],
    total: null,
  },
  userAsCoauthor: {
    list: [],
    total: null,
  },
};

const actions = {
  [LOAD_USER_COAUTHORS]({ commit }, { date_from = "", date_to = "" }) {
    return Api.collaboration.coauthor
      .all(date_from, date_to)
      .then((response) => {
        if (!response.success) {
          throw new Error(response.error);
        }

        commit(SET_USER_COAUTHORS, response.data);
      })
      .catch((e) => e);
  },
  [LOAD_USER_AS_COAUTHOR]({ commit }, { date_from = "", date_to = "" }) {
    return Api.collaboration.coauthor
      .selfData(date_from, date_to)
      .then((response) => {
        if (!response.success) {
          throw new Error(response.error);
        }

        commit(SET_USER_AS_COAUTHOR, response.data);
      })
      .catch((e) => e);
  },
};

const mutations = {
  [SET_USER_COAUTHORS](state, data) {
    state.userCoauthors.byItem = data?.by_item || [];
    state.userCoauthors.byCoauthor = data?.by_coauthor || [];
    state.userCoauthors.total = data?.total || null;
  },
  [SET_USER_AS_COAUTHOR](state, { list, total }) {
    state.userAsCoauthor.list = list;
    state.userAsCoauthor.total = total;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
